import React from 'react';
import {SearchResult} from '../types/searchResult';
import Moment from "react-moment";
import parseHtml from 'html-react-parser';
import 'moment/min/moment-with-locales'
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/it';
import {getBaseUrl} from "../service/api";
import {useMediaQuery} from "react-responsive";

type SearchResultItemProps = {
    item: SearchResult
}

export function SearchResultItem({item}: SearchResultItemProps) {

    const currentLang = document.documentElement.lang;
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' });

    return (
        <div className='search__result--item'>
            <a href={item.url} title={item.title} target={item.isBlank ? '_blank' : ''}>
                {item.image && !isMobile &&
                    <div className='result__item--image'>
                        <div className='result__item--image-inner'>
                            <img src={item.image.uri} alt={item.image.alt} title={item.image.title}/>
                        </div>
                    </div>
                }

                {item.isFallbackImage && !isMobile &&
                    <div className='result__item--image'>
                        <div className='result__item--image-inner'>
                            <img src={item.fallbackImageUri} alt={item.title} title={item.title}/>
                        </div>
                    </div>
                }

                <div className='result__item--infos'>
                    {item.date &&
                        <div className='result__item--date'>
                        <span>
                            <Moment format="LL" locale={currentLang}>{(item.date)}</Moment>
                        </span>
                        </div>
                    }

                    {item.title &&
                        <div className='result__item--title'>
                            <h3>{parseHtml(item.title)}</h3>
                        </div>
                    }

                    {item.text &&
                        <div className='result__item--text'>
                            <p>{parseHtml(item.text)}</p>
                        </div>
                    }
                </div>
            </a>
        </div>
    );
}
